import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { decodeString } from 'lib/stringUtils';

import styles from './styles.module.scss';

function LiftOut({ size, text }) {
  const containerClasses = ['mv8', 'liftOut'];
  const textClasses = ['ma0 mt6 f8 lh-none founders-cond'];

  if (size === 'small') {
    containerClasses.push(styles.smallContainer, 'mt2-m');
  } else if (size === 'large') {
    containerClasses.push(styles.largeContainer);
    textClasses.push('f9-l f10-xl');
  }

  if (text) {
    return (
      <div className={classNames(styles.container, containerClasses)}>
        <p className={classNames(styles.text, textClasses)}>
          {decodeString(text)}
        </p>
      </div>
    );
  }

  return null;
}

LiftOut.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  text: PropTypes.string.isRequired,
};

LiftOut.defaultProps = {
  size: 'small',
};

export default LiftOut;
